import { AlarmDetailsDto, isAcknowledged,  useAckAlarmsMutation } from '../../services/alarm'
import { Button, KIND, SIZE, SHAPE } from "baseui/button";
import { useIntl, FormattedMessage } from 'react-intl';


export const AckAlarmButton = (props: {alarms:  AlarmDetailsDto[]}) => {

    const alarms = props.alarms;
    const hasAlarmToAck = alarms.some(elm => !isAcknowledged(elm));
    const disableButton = !hasAlarmToAck;
    const [ack, { data, isLoading, error }] = useAckAlarmsMutation()

    const handleAck = () => {
        const items = alarms.map(elm => ({ resourceGroupId: elm.resourceGroupId, alarmId: elm.id }))
        console.info("AckAlarms",items);
        ack(items);
    }
    return (
        <Button kind={KIND.secondary}
            size={SIZE.compact}
            shape={SHAPE.pill}
            isLoading={isLoading}
            disabled={disableButton}
            onClick={handleAck}>
            <FormattedMessage id='alarms.ackAlarm' defaultMessage='Acknowledge'></FormattedMessage>
        </Button>
    )
}

